export default __webpack_public_path__ + "static/media/truck.56e60438.jpg";